export default "__VITE_ASSET__CjW_4MTl__"